
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    image: 'https://public.readdy.ai/ai/img_res/a8bda022e27faddeab33bc33c2709882.jpg',
    tag: '2025年4月 新規開業',
    title: '岡山で心と体を整える\nあなたの健康パートナー',
    subtitle: '痛みの根本改善から日々の疲れまで、一人ひとりに寄り添う鍼灸治療',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20scene%20of%20a%20Japanese%20female%20acupuncturist%20in%20white%20coat%20having%20a%20friendly%20conversation%20with%20a%20smiling%20middle-aged%20Japanese%20patient%20in%20a%20cozy%20clinic%20waiting%20room%2C%20soft%20pastel%20mint%20green%20overlay%2C%20comfortable%20seating%20area%20with%20plants%2C%20natural%20wood%20furniture%2C%20gentle%20afternoon%20sunlight%2C%20professional%20yet%20welcoming%20atmosphere%2C%20both%20people%20showing%20genuine%20smiles%20and%20trust%2C%20high%20quality%20photography&width=1920&height=1080&seq=hero-slide-2&orientation=landscape',
    tag: '完全予約制',
    title: '経験豊富な国家資格保持者が\n丁寧に施術いたします',
    subtitle: '2000年の開業以来、岡山市を中心に地域の皆様の健康をサポート',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20Japanese%20acupuncture%20clinic%20waiting%20room%20interior%2C%20bright%20and%20airy%20space%20with%20large%20windows%2C%20comfortable%20modern%20seating%20in%20soft%20pastel%20peach%20tones%2C%20indoor%20plants%20creating%20a%20natural%20healing%20environment%2C%20clean%20minimalist%20design%20with%20warm%20wooden%20accents%2C%20soft%20natural%20lighting%2C%20welcoming%20and%20calming%20atmosphere%2C%20professional%20healthcare%20facility%2C%20high%20quality%20architectural%20photography&width=1920&height=1080&seq=hero-slide-3&orientation=landscape',
    tag: '初回限定割引',
    title: 'あなたの症状に合わせた\nオーダーメイド治療',
    subtitle: '肩こり・腰痛・自律神経の不調・美容鍼まで幅広く対応',
  },
];

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative h-[85vh] mt-16 sm:mt-20 mx-3 sm:mx-5 overflow-hidden rounded-[20px] sm:rounded-[30px]">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="relative w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
            
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6">
              <div className="bg-white/20 backdrop-blur-sm px-4 sm:px-6 py-1.5 sm:py-2 rounded-full mb-4 sm:mb-6">
                <span className="text-white text-xs sm:text-sm font-medium">{slide.tag}</span>
              </div>
              
              <h1 className="font-serif text-3xl sm:text-5xl md:text-6xl lg:text-7xl text-white mb-4 sm:mb-6 leading-tight whitespace-pre-line max-w-4xl px-2">
                {slide.title}
              </h1>
              
              <p className="font-sans text-sm sm:text-base lg:text-lg text-white/90 mb-8 sm:mb-12 max-w-2xl px-2">
                {slide.subtitle}
              </p>
            </div>
          </div>
        </div>
      ))}

      {/* CTA Buttons */}
      <div className="absolute bottom-12 sm:bottom-16 left-0 right-0 flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 z-10 px-4">
        <Link
          to="/about"
          className="bg-sub text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium text-sm sm:text-base hover:bg-sub/80 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
        >
          初めての方へ
          <i className="ri-arrow-right-line"></i>
        </Link>
        <Link
          to="/booking"
          className="bg-white text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-full font-medium text-sm sm:text-base hover:bg-white/90 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
        >
          <i className="ri-phone-fill"></i>
          ご予約はこちら
        </Link>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-4 sm:bottom-6 left-0 right-0 flex justify-center gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
            }`}
            aria-label={`スライド ${index + 1}`}
          ></button>
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;
